<h2 mat-dialog-title class="flex items-center gap-2" i18n>
  <mat-icon class="text-primary">lock</mat-icon>
  Confidential Documents
</h2>
<mat-dialog-content class="mat-typography min-w-[300px] max-w-[500px]">
  <div class="flex flex-col gap-4">
    <p i18n>
      This application contains confidential documents. To access these protected resources, you need to log in.
    </p>
    <p class="font-medium text-blue-800 bg-blue-50 p-3 rounded-md border border-blue-200" i18n>
      <strong>Note:</strong> Logging in is <strong>optional</strong>. If you choose not to log in, you will still have full access to all public documents.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="p-4 gap-3 bg-gray-50">
  <button mat-button mat-dialog-close class="text-gray-600" i18n>Continue as Guest</button>
  <button mat-flat-button color="primary" class="font-bold px-6 py-2 shadow-md transform hover:scale-105 transition-transform" (click)="login()" i18n>Log In</button>
</mat-dialog-actions>
